import { useDispatch, useSelector } from "react-redux";

import {
  clearPageTitle as clearPageTitleAction,
  resetLayoutState as resetLayoutStateAction,
  setPageTitle as setPageTitleAction,
} from "@src/services/state/layoutReducer";
import type { RootState } from "@src/services/state/store";

export const useLayout = () => {
  const dispatch = useDispatch();
  const pageTitle = useSelector((state: RootState) => state.layout.pageTitle);

  const setPageTitle = (title: string) => {
    dispatch(setPageTitleAction(title));
  };

  const clearPageTitle = () => {
    dispatch(clearPageTitleAction());
  };

  const resetLayoutState = () => {
    dispatch(resetLayoutStateAction(undefined));
  };

  return {
    pageTitle,
    setPageTitle,
    clearPageTitle,
    resetLayoutState,
  };
};
